import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ApiRespuesta, ApiRespuestaPaginada } from '@app/models/ApiRespuesta.interface';
import { catchError, map, Observable } from 'rxjs';
import { handleError } from '../tools/handle-error';
import { Gerenciamiento } from '@app/models/gerenciamiento';

export type GerenciamientoPayload = Partial<Gerenciamiento> & { [key: string]: any };

@Injectable({ providedIn: 'root' })
export class GerenciamientoService {
    private readonly http = inject(HttpClient);
    private readonly baseUrl = `${environment.url}gerenciamiento`;

    create(payload: FormData): Observable<Gerenciamiento> {
        return this.http.post<ApiRespuesta<Gerenciamiento>>(this.baseUrl, payload).pipe(
            catchError((err) => handleError(err)),
            map((data) => data.result)
        );
    }

    getAll(params?: HttpParams): Observable<{ entities: Gerenciamiento[]; count: number }> {
        const url = `${this.baseUrl}/get/all`;
        
        const headers = new HttpHeaders({
            'Cache-Control': 'no-cache, no-store, must-revalidate',
            'Pragma': 'no-cache',
            'Expires': '0'
        })

        return this.http
            .get<ApiRespuestaPaginada<Gerenciamiento>>(url, { params, headers })
            .pipe(
                map(res => res.result),
                catchError(err => handleError(err))
            );
    }

    getOne(id: string): Observable<Gerenciamiento> {
        const url = `${this.baseUrl}/${id}`;
        return this.http.get<ApiRespuesta<Gerenciamiento>>(url).pipe(
            catchError((err) => handleError(err)),
            map((data) => data.result)
        );
    }

    update(id: string, payload: GerenciamientoPayload): Observable<Gerenciamiento> {
        const url = `${this.baseUrl}/${id}`;
        return this.http.put<ApiRespuesta<Gerenciamiento>>(url, payload).pipe(
            catchError((err) => handleError(err)),
            map((data) => data.result)
        );
    }

    getActivosAhora(): Observable<Pick<Gerenciamiento, 'id' | 'destino' | 'fecha_hora_salida' | 'fecha_hora_llegada'>[]> {
        const url = `${this.baseUrl}/activos-ahora`;
        return this.http
            .get<{ ok: boolean; result: any[] }>(url)
            .pipe(
                map((res) => res.result),
                catchError((err) => handleError(err))
            );
    }

    toggleActivo(id: string): Observable<Gerenciamiento> {
        const url = `${this.baseUrl}/toggle/activo/${id}`;
        return this.http.post<ApiRespuesta<Gerenciamiento>>(url, null).pipe(
            catchError((err) => handleError(err)),
            map((data) => data.result)
        );
    }

    downloadExcel(params?: HttpParams): Observable<Blob> {
        const url = `${this.baseUrl}/download-excel`;
        return this.http
            .get(url, { params, responseType: 'blob' })
            .pipe(catchError((err) => handleError(err)));
    }
}
